import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Flex} from '@travel-frontend/ui-components';

type Props = {
  noBorders?: boolean;
};

export const FilterStrip = styled(Flex)<Props>(
  ({theme, noBorders}) => css`
    border: 1px solid ${theme.colors.borderSecondary};
    border-left: ${noBorders
      ? 'none'
      : `1px solid ${theme.colors.borderSecondary}`};
    border-right: ${noBorders
      ? 'none'
      : `1px solid ${theme.colors.borderSecondary}`};
    border-radius: ${noBorders ? '0' : '5px'};
    display: grid;
    grid-auto-flow: row;
    ${theme.spacing('padding', 'boxes/medium')}
    min-width: fit-content;
  `
);
